import React from 'react';
import { Link } from 'react-router-dom';

import Css from './WhyFly.scss';
import { Col, Row, Container } from 'reactstrap';
import ImportImages from '@src/importImages';

const WhyFlyImg = ImportImages('/home/why-fly.jpg');

const whyfly = props => {
  let heightStyle = {};

  if (window.innerWidth < 992) {
    heightStyle.minHeight = props.screenHeight + 'px';
  } else {
    heightStyle.height = props.screenHeight + 'px';
  }

  return (
    <div id={props.id} className={props.className} style={heightStyle}>
      <Container fluid={true} className={Css.container}>
        <Row>
          <Col
            lg={{ offset: 1, size: 4 }}
            sm={{ offset: 3, size: 6 }}
            className={'text-center d-flex align-items-center'}
          >
            <img src={WhyFlyImg} className={'img-fluid'} alt={'Why Fly'} />
          </Col>
          <Col
            xl={props.heightSm ? { size: 6 } : { offset: 1, size: 4 }}
            lg={{ size: 6 }}
            className={Css.text}
          >
            <div
              className={'subheader lakes-medium'}
              style={{ fontSize: '34px', fontWeight: '600' }}
            >
              Why JetSuite?
            </div>
            <p
              className={'asap-regular font-md'}
              style={{ lineHeight: '28px' }}
            >
              Because at JetSuite, we define luxury as moving through the sky
              with grace.
            </p>
            <p
              className={'asap-regular font-md'}
              style={{ lineHeight: '28px' }}
            >
              Anticipate individualized amenities, a fleet of
              beautifully-designed, state-of-the-art jets, the friendliest, most
              knowledgeable pilots in the game, and the assurance of ten years
              of operations under our belt. JetSuite infuses every trip with the
              spirit of hospitality for a remarkable light-jet experience that
              resonates with comfort, relaxation, and luminous possibility.
            </p>
            <p
              className={'asap-regular font-md'}
              style={{ lineHeight: '28px' }}
            >
              Make connections. Be yourself. Breathe. We’re here for you.
            </p>

            <Link to={'/subscribe'} className={'btn btn-default'}>
              Learn More
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default whyfly;



// WEBPACK FOOTER //
// ./src/components/Home/WhyFly/WhyFly.js